import { GetAllManipulationDetailFiltersDTO, GetAllManipulationDetailsDTO, ManipulationDetailDTO } from "./dto";
import { ManipulationDetailServiceImpl } from "./serviceImpl";

export interface ManipulationDetailService {
    CreateManipulationDetail(data: ManipulationDetailDTO): Promise<void>
    DeleteManipulationDetail(id: string): Promise<void>
    GetAllManipulationDetails(filters: GetAllManipulationDetailFiltersDTO): Promise<GetAllManipulationDetailsDTO>
    GetManipulationDetailById(id: string): Promise<ManipulationDetailDTO>
}

export function NewManipulationDetailService(): ManipulationDetailService {
    return new ManipulationDetailServiceImpl()
}